<template>
  <el-dialog title="指/改派护工" :visible.sync="dialogVisible" width="600px" center destroy-on-close	>
    <el-form :model="editForm">
      <el-form-item label="护工" :label-width="formLabelWidth">
        <el-select v-model="editForm.nurse_id" allow-create filterable default-first-option placeholder="请选择护工">
          <el-option
            v-for="hospital in nurses"
            :label="`${hospital.name}/${hospital.tel}`"
            :value="hospital.id"
            :key="hospital.id"
          ></el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取 消</el-button>
      <el-button type="primary" @click="handleSubmit">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { fetchNurseList, allocateOrderInfoById } from '../../../api'

export default {
  name: 'ChangeOrderNurseInfo',
  data() {
    return {
      dialogVisible: false,
      formLabelWidth: '153px',
      editForm: {
        order_id: '',
        nurse_id: ''
      },
      nurses: []
    }
  },
  methods: {
    async handleOpen(val) {
      const { orderInfo: { id: order_id } } = val
      console.log(order_id)
      await this.getNurseList()
      this.editForm = {
        order_id,
        nurse_id: ''
      }
      this.dialogVisible = true
    },
    async getNurseList() {
      const { status, data } = await fetchNurseList()
      if (status) {
        console.log(data)
        this.nurses = data
      }
    },
    handleSubmit() {
      const { order_id, nurse_id } = this.editForm

      if (!nurse_id) return this.$message({ message: '请选择护工！', type: 'warning' })
      const params = {
        order_id,
        nurse_id
      }
      allocateOrderInfoById(params).then(res => {
        if (res.status) {
          this.$message.success(res.msg)
          this.handleClose()
          this.$emit('update')
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    handleClose() {
      this.dialogVisible = false
    },
    inputFn(_Text) {
      this.editForm[_Text] = (this.editForm[_Text]).replace(/[^\d]/g, '').replace(/^0{1,}/g, '')
    }
  }
}
</script>

<style scoped>

</style>
